import { render } from "./orderDataRecord.vue?vue&type=template&id=59a2ace6"
import script from "./orderDataRecord.vue?vue&type=script&lang=js"
export * from "./orderDataRecord.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__